module.exports = __webpack_public_path__ + "static/media/42-8.bfd99486.mp3";